/** Heading scale shared by field-tier Plate editor and read-only markdown bodies. */
export const MARKDOWN_FIELD_HEADING_CLASS = {
  h1: 'mt-0 pb-1 font-bold font-heading text-2xl',
  h2: 'mt-[1.4em] pb-px font-heading font-semibold text-xl tracking-tight',
  h3: 'mt-[1em] pb-px font-heading font-semibold text-lg tracking-tight',
  h4: 'mt-[0.75em] font-heading font-semibold text-lg tracking-tight',
  h5: 'mt-[0.75em] font-semibold text-lg tracking-tight',
  h6: 'mt-[0.75em] font-semibold text-base tracking-tight',
} as const

export type MarkdownFieldHeadingLevel = keyof typeof MARKDOWN_FIELD_HEADING_CLASS

export const MARKDOWN_FIELD_HEADING_BASE = 'relative mb-1'

export function markdownFieldHeadingClass(level: MarkdownFieldHeadingLevel): string {
  return `${MARKDOWN_FIELD_HEADING_BASE} ${MARKDOWN_FIELD_HEADING_CLASS[level]}`
}

/**
 * Tailwind Typography modifiers for `MarkdownContent` / `MARKDOWN_PROSE`.
 * Static literal so Tailwind can scan every `prose-h*` utility.
 */
export const MARKDOWN_FIELD_HEADING_PROSE =
  'prose-h1:mt-0 prose-h1:pb-1 prose-h1:mb-1 prose-h1:font-bold prose-h1:font-heading prose-h1:text-2xl prose-h2:mt-[1.4em] prose-h2:pb-px prose-h2:mb-1 prose-h2:font-heading prose-h2:font-semibold prose-h2:text-xl prose-h2:tracking-tight prose-h3:mt-[1em] prose-h3:pb-px prose-h3:mb-1 prose-h3:font-heading prose-h3:font-semibold prose-h3:text-lg prose-h3:tracking-tight prose-h4:mt-[0.75em] prose-h4:mb-1 prose-h4:font-heading prose-h4:font-semibold prose-h4:text-lg prose-h4:tracking-tight prose-h5:mt-[0.75em] prose-h5:mb-1 prose-h5:font-semibold prose-h5:text-lg prose-h5:tracking-tight prose-h6:mt-[0.75em] prose-h6:mb-1 prose-h6:font-semibold prose-h6:text-base prose-h6:tracking-tight'
